<template>
    <div class="cardContainer">
        <div class="title"><van-icon name="checked" size="20px" color="#fff" style="margin-right: 10px;" />
           {{ title }}</div>
        <img src="@/assets/themeFour/misteryGift.png" alt="gift card" style="width: 30%;" />
        <div class="dailyPrize">{{ bottomText }}</div>
        <div>
            <div v-if="alreadyClaimed" class="claimedButton">{{ rewardType === 3 ? $t('misteryBox.alreadyClaimToday') :
                $t('misteryBox.alreadyClaimed') }}</div>
            <div v-else class="claimButton" @click="onClickButton">{{ $t('misteryBox.clickToClaim') }}</div>
        </div>
        <ClaimPopup ref="claimRef" />
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
        <LoadingScreen ref="loadingRef" />
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ClaimPopup from './claimPopup.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { processClaimReward } from '@/view/misteryBox/supportScript';

const emits = defineEmits(['updateInfo'])

const props = defineProps<{
    title?: string,
    bottomText?: string,
    rewardType?: number,
    alreadyClaimed?: boolean,
    exchangeType?: number,
}>()
const loadingRef = ref()
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const claimRef = ref()
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const onClickButton = () => {
    claimReward(props.rewardType)
}

const claimReward = async (rewardType?: number) => {
    await processClaimReward(
        {
            rewardType,
            exchangeType: props.exchangeType
        },
        {
            onStart: () => loadingRef.value?.open(),
            onSuccess: (res) => {
                emits('updateInfo');
                claimRef.value?.open({
                    exchangeType: props.exchangeType,
                    reward: res.reward,
                });
            },
            onError: (err) => showError(err),
            onFinally: () => loadingRef.value?.close(),
        }
    );
};
</script>
<style scoped>
.cardContainer {
    padding: 20px;
    border-radius: 5px;
    background: #024A49;
    color: #fff;
    padding: 15px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.title {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.dailyPrize {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.721);
    padding: 5px 0;
}

.claimButton {
    background: linear-gradient(90deg, rgb(1, 73, 72) -18%, rgb(15, 177, 175) 122%);
    color: #fff;
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 15px;
    font-weight: bold;
}
.claimedButton{
    background: linear-gradient(90deg, rgb(38, 71, 71) -18%,rgb(107, 139, 138) 122%);
    color: #ffffffc4;
    padding: 10px 20px;
    border-radius: 5px;
    margin-top: 15px;
    font-weight: bold;
}
</style>